module.exports = __webpack_public_path__ + "woo.9fb0ae491818043b7e472b2a0660e22d.svg";